/**
 * Javascript for basket view of ige_shop.
 * Product Owner: Raphael Wälterlin <raphael.waelterlin@cabag.ch>
 * Author: Markus Gehrig <markus.gehrig@cabag.ch>
 * Date: 15. Apr 2019
 * 
 * Customer: Prospecia Rara
 * Company: cab services ag
 */

/**
 * Load external JavaScript Libaries
 */
var $           = require('../../../../../../../webpack/node_modules/jquery');
var nunjucks    = require('../../../../../../../webpack/node_modules/nunjucks');
var storage     = require("./storage.js");
var translation = require("./translation.js");

/**
 * Global vars
 */
var container = ".psr-shop-basket";

/**
 * show Basket
 */
function showBasket() {
    nunjucks.configure('/template/dist/views-shop', {autoescape: true});

    translations = {
        "amount": translation.getTranslation("amount"),
        "remove": translation.getTranslation("remove"),
        "sumtotal": translation.getTranslation("sumtotal"),
        "porto": translation.getTranslation("porto"),
        "checkout": translation.getTranslation("checkout"),
        'vat': translation.getTranslation("vat")
    };

    var items = getBasket();

    $('.amount').html(items.numberofproducts);

    var showVat = window.showVat;

    var view = nunjucks.render('basket.twig', {currency: currency, items: items, translations: translations, showVat: showVat});
    $(container).html(view);

    $('.psr-shop-basket-remove').click(function() {
        remove($(this).data('uid'));
    });
}

/**
 * Order a product
 * @param {array} product 
 * @param {int} quantity 
 * @param {int} uid 
 */
function order(product, quantity, uid) {
    if (quantity > 0){
        var basket = getBasket();

        basket.totalprice += quantity * product.price;
        basket.formatedTotalprice = translation.currencyFormatter(basket.totalprice)

        basket.numberofproducts += quantity;

        index = basket.products.findIndex(basket => basket.uid === uid);

        if (index >= 0) {
            basket.products[index].quantity      += quantity;
            basket.products[index].price         += quantity * basket.products[index].product.price;

            basket.products[index].formatedPrice = translation.currencyFormatter(basket.products[index].price)
        }
        else {
            order = {uid: uid, quantity: quantity, price: quantity * product.price, product: product, formatedPrice: translation.currencyFormatter(quantity * product.price), formatedProductPrice: translation.currencyFormatter(product.price)};
            basket.products.push(order);
        }

        setBasket(basket);
        showBasket();           // refresh basket
    }
}

function remove(uid) {
    var basket = getBasket();
    var index = basket.products.findIndex(basket => basket.uid === uid);

    if (index >= 0) {
        basket.totalprice -= basket.products[index].price;
        basket.numberofproducts -= basket.products[index].quantity;

        basket.formatedTotalprice = translation.currencyFormatter(basket.totalprice);
        basket.products.splice(index, 1);
        setBasket(basket);
        showBasket(); // refresh basket
    }
}

/**
 * 
 * @param {int} uid 
 * @param {int} quantity 
 */
function changeQuantity(uid, quantity) {
    var basket = getBasket();
    var index = basket.products.findIndex(basket => basket.uid === uid);

    if( quantity < 1 ) {
        remove(uid);
        basket = getBasket();
    }
    else {
        if (index >= 0) {

            if(basket.products[index].quantity == quantity){

            }
            else if (basket.products[index].quantity < quantity) {
                basket.totalprice               += ( quantity - basket.products[index].quantity ) * basket.products[index].product.price;
                basket.products[index].price    += ( quantity - basket.products[index].quantity ) * basket.products[index].product.price;
                basket.numberofproducts         += quantity;

                basket.formatedTotalprice               = translation.currencyFormatter(basket.totalprice)
                basket.products[index].quantity         = quantity;
                basket.products[index].formatedPrice    = translation.currencyFormatter(basket.products[index].price)
            }
            else {
                basket.totalprice               -= ( basket.products[index].quantity - quantity ) * basket.products[index].product.price;
                basket.products[index].price    -= ( basket.products[index].quantity - quantity ) * basket.products[index].product.price;
                basket.numberofproducts         -= quantity;

                basket.formatedTotalprice               = translation.currencyFormatter(basket.totalprice)
                basket.products[index].quantity         = quantity;
                basket.products[index].formatedPrice    = translation.currencyFormatter(basket.products[index].price)
            }
        }
    }

    setBasket(basket);
    showBasket(); // refresh basket
}

function setBasket(basket) {
    storage.setItem('basket', JSON.stringify(basket));
}

function getBasket() {
    var basket = JSON.parse(storage.getItem('basket')) || {numberofproducts: 0, totalprice: 0, products: []};

    return basket;
}

module.exports = {
    setBasket,
    getBasket,
    order,
    showBasket,
    changeQuantity,
    remove
}
